import { FLASH_MESSAGE_REMOVE, FLASH_MESSAGE_ADD, FLASH_MESSAGES_LOADED, } from "../constants";
import { post } from '../Services/http';

export const flashMessageRemove = (message) => ({
    type: FLASH_MESSAGE_REMOVE,
    payload: message,
});

export const flashMessageAdd = (message) => ({
    type: FLASH_MESSAGE_ADD,
    payload: message,
});

export const flashMessagesLoaded = (messages) => ({
    type: FLASH_MESSAGES_LOADED,
    payload: messages,
});

export const removeFlashMessage = (message, closedByUser) => async (dispatch) => {
    if (!message) return;
    if (closedByUser && message?.messageSystemId) {
        try {
            await post(`/api/flashmessage/close/${message.messageSystemId}`);
        } catch {}
    }
    dispatch(flashMessageRemove(message));
}

export const addFlashMessage = (message) => (dispatch) => {
    dispatch(flashMessageAdd({...message, messageId: crypto.randomUUID()}));
}

export const loadFlashMessages = (messages) => {
    dispatch(flashMessagesLoaded(messages));
}